import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgQuestion = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M15.313 19.688a1.313 1.313 0 1 1-2.626 0 1.313 1.313 0 0 1 2.626 0ZM14 7.874c-2.413 0-4.375 1.766-4.375 3.938v.437a.875.875 0 1 0 1.75 0v-.438c0-1.203 1.178-2.187 2.625-2.187s2.625.984 2.625 2.188C16.625 13.015 15.447 14 14 14a.875.875 0 0 0-.875.875v.875a.875.875 0 1 0 1.75 0v-.079c1.995-.366 3.5-1.958 3.5-3.858 0-2.172-1.962-3.938-4.375-3.938ZM25.375 14A11.375 11.375 0 1 1 14 2.625 11.387 11.387 0 0 1 25.375 14Zm-1.75 0A9.625 9.625 0 1 0 14 23.625 9.636 9.636 0 0 0 23.625 14Z" />
  </svg>
);
export default SvgQuestion;
